import React, {
  useState,
  createContext,
  Dispatch,
  SetStateAction
} from "react";
import { PDFFile } from "../global/types";

interface FilesContextOptions {
  pdfs: PDFFile[];
  setPdfs: Dispatch<SetStateAction<PDFFile[]>>;
  filteredPdfsByIds: (pdfIds: number[]) => PDFFile[];
}

export const FilesContext = createContext<FilesContextOptions>({
  pdfs: [],
  setPdfs: () => [],
  filteredPdfsByIds: () => []
});

export const FilesProvider: React.FC = ({ children }) => {
  const [pdfs, setPdfs] = useState<PDFFile[]>([]);

  const filteredPdfsByIds = (pdfIds : number[] = []) : PDFFile[] => {
    return pdfs.filter(pdf => pdfIds.indexOf(pdf.id) !== -1);
  }

  return (
    <FilesContext.Provider
      value={{
        pdfs,
        setPdfs,
        filteredPdfsByIds
      }}
    >
      {children}
    </FilesContext.Provider>
  );
};
